export default __webpack_public_path__ + "media/big-goose-party3x.221a6883.png";